//Funciones comunes
import { LogErrors } from './../LogErrors'
//import { useLanguage } from './../LanguageContext' // Importa el hook
import { ValidateSqlInjection } from './Security'

//Funciones personalizadas
import { SignUp as DLSignUp, GetAllStates as DLGetAllStates, GetStatesContracted as DLGetStatesContracted, GetNormalSchoolSectors as DLGetNormalSchoolSectors, GetNormalSchoolsByState as DLGetNormalSchoolsByState, GetMajorsByNormalSchool as DLGetMajorsByNormalSchool } from './../DL/SignUps' //GetFieldsData as DLGetFieldsData


// Agregar el multiidioma a mensaje de error


/**
 * Función que valida los datos ingresados, realiza la confirmación y devuelve un resultado
 * @param {Object} formData Información del formulario
 * @returns {Object} Resultado del proceso { success: boolean, errors: Object, data: Object }
 */
const SignUp = async (formData, minDate, maxDate, schools, states, majors) => {
    //const { translate } = useLanguage() // Obtén la función de traducción desde el contexto
    
    try {
        // Llamar a la capa de datos para autenticar al usuario
        const response = await ValidateForm(formData, minDate, maxDate, schools, states, majors)
        
        if (response.success) {            
            const signUpResponse = await DLSignUp(response.data)
            
            if (signUpResponse.success) {
                return { success: true, data: signUpResponse.data }
            } else {
                return { success: false, message: signUpResponse.message }
            }
        } else {
            if (typeof response.message === 'string') {
                return { success: false, message: response.message }
            } else {
                const errorData = {
                    formErrors: response.message
                }
    
                return { success: false, message: errorData }
            }
        }
    } catch (error) {
        await LogErrors('SignUp BL SignUps', error)
        return { success: false, message: error || 'Ocurrió un error inesperado'}
    }
}

const ValidateForm = async (formData, minDate, maxDate, schools, states, majors) => {
    try {
        // Validación de los datos del formulario
        const errors = {}
        //const regex = /^[\p{L}\p{N} ]+$/u
        const regex = /^[a-záéíóúüñ0-9 ]+$/
        const regexNormalName = /^[a-záéíóúüñ0-9\(\)\.\,\'\" ]+$/

        if (formData.name) {
            //if (!/^[A-Za-z0-9]+$/.test(formData.name)) {
            if (!regex.test(formData.name.toLowerCase())) {
                errors.name = 'El nombre contiene caracteres inválidos'
            } else if (ValidateSqlInjection(formData.name)) {
                errors.name = 'El nombre que escribiste es inválido'
            }
        } else {
            errors.name = 'El nombre es obligatorio'
        }

        if (formData.paternalSurname) {
            if (!regex.test(formData.paternalSurname.toLowerCase())) {
                errors.paternalSurname = 'El apellido paterno contiene caracteres inválidos'
            } else if (ValidateSqlInjection(formData.paternalSurname)) {
                errors.paternalSurname = 'El apellido paterno que escribiste es inválido'
            }
        } else {
            errors.paternalSurname = 'El apellido paterno es obligatorio'
        }

        if (formData.maternalSurname) {
            if (!regex.test(formData.maternalSurname.toLowerCase())) {
                errors.maternalSurname = 'El apellido materno contiene caracteres inválidos'
            } else if (ValidateSqlInjection(formData.maternalSurname)) {
                errors.maternalSurname = 'El apellido materno que escribiste es inválido'
            }
        } else {
            errors.maternalSurname = 'El apellido materno es obligatorio'
        }

        if (formData.birthdate) {
            if (!IsDateInRange(formData.birthdate, minDate, maxDate)) {
                errors.birthdate = 'La fecha de nacimiento debe estar entre los últimos 150 años'
            } else if (ValidateSqlInjection(formData.birthdate)) {
                errors.birthdate = 'La fecha de nacimiento contiene patrones inválidos'
            }
        } else {
            errors.birthdate = 'La fecha de nacimiento es obligatoria'
        }

        if (formData.nameOfHomeSchool) {
            if (!regexNormalName.test(formData.nameOfHomeSchool.toLowerCase())) {
                errors.nameOfHomeSchool = 'El nombre de tu escuela de procedencia contiene caracteres inválidos'
            } else if (ValidateSqlInjection(formData.nameOfHomeSchool)) {
                errors.nameOfHomeSchool = 'El nombre de tu escuela de procedencia que escribiste es inválido'
            }
        } else {
            errors.nameOfHomeSchool = 'El nombre de tu escuela de procedencia es obligatorio'
        }

        if (formData.average) {
            const average = parseFloat(formData.average)
          
            if (isNaN(average) || average < 0 || average > 10) {
                errors.average = 'El promedio general debe estar entre 0 y 10'
            } else if (!/^([0-9]|10)(\.\d{1,2})?$/.test(formData.average)) {
                errors.average = 'El promedio debe tener un formato válido (e.g., 10, 9.5, 8.75)'
            } else if (ValidateSqlInjection(formData.average)) {
                errors.average = 'El promedio general contiene patrones inválidos'
            }
        } else {
            errors.average = 'El promedio general es obligatorio'
        }
        
        if (formData.normalState) {
            if (!states.some(state => state.id === parseInt(formData.normalState))) {
                errors.normalState = 'Selecciona un estado válido'
            }
        } else {
            errors.normalState = 'Seleccionar el estado de la escuela normal es obligatorio'
        }

        // if (formData.normalState) {
        //     if (!regex.test(formData.normalState)) {
        //         errors.normalState = 'El estado de la escuela normal contiene caracteres inválidos'
        //     } else if (ValidateSqlInjection(formData.normalState)) {
        //         errors.normalState = 'El estado de la escuela normal que seleccionaste es inválido'
        //     }
        // } else {
        //     errors.normalState = 'Seleccionar el estado de la escuela normal es obligatorio'
        // }
        
        if (formData.normalSchool) {
            if (!schools.some(school => school.id === parseInt(formData.normalSchool))) {
                errors.normalSchool = 'Selecciona una escuela normal válida'
            }
        } else {
            errors.normalSchool = 'Seleccionar la escuela normal es obligatorio'
        }

        // if (formData.normalSchool) {
        //     if (!regex.test(formData.normalSchool)) {
        //         errors.normalSchool = 'La escuela normal contiene caracteres inválidos'
        //     } else if (ValidateSqlInjection(formData.normalSchool)) {
        //         errors.normalSchool = 'La escuela normal que seleccionaste es inválida'
        //     }
        // } else {
        //     errors.normalSchool = 'Seleccionar la escuela normal es obligatorio'
        // }
        
        if (formData.major) {
            if (!majors.some(school => school.id === parseInt(formData.major))) {
                errors.major = 'Selecciona una especialidad válida'
            }
        } else {
            errors.major = 'Seleccionar la especialidad es obligatorio'
        }

        // Si hay errores, retornar inmediatamente
        if (Object.keys(errors).length === 0) {
            return { success: true, data: formData }
        } else {
            return { success: false, message: errors }
        }
    } catch (error) {
        await LogErrors('ValidateForm BL SignUps', error)
        return { success: false, message: error || 'Ocurrió un error inesperado' }
    }
}

const GetAllStates = async () => {
    try {
        const response = await DLGetAllStates()

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: true, message: response.message }
        }
    } catch (error) {
        await LogErrors('GetAllStates BL SignUps', error)
        return { success: false, message: error || 'Ocurrió un error inesperado' }
    }
}

const GetStatesContracted = async () => {
    try {
        const response = await DLGetStatesContracted()

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: true, message: response.message }
        }
    } catch (error) {
        await LogErrors('GetStatesContracted BL SignUps', error)
        return { success: false, message: error || 'Ocurrió un error inesperado' }
    }
}

const GetNormalSchoolSectors = async () => {
    try {
        const response = await DLGetNormalSchoolSectors()

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: true, message: response.message }
        }
    } catch (error) {
        await LogErrors('GetNormalSchoolSectors BL SignUps', error)
        return { success: false, message: error || 'Ocurrió un error inesperado' }
    }
}

const GetNormalSchoolsByState = async (idState) => {
    try {
        const response = await DLGetNormalSchoolsByState(idState)

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: true, message: response.message }
        }
    } catch (error) {
        await LogErrors('GetNormalSchoolsByState BL SignUps', error)
        return { success: false, message: error || 'Ocurrió un error inesperado' }
    }
}

const GetMajorsByNormalSchool = async (idNormalSchool) => {
    try {
        const response = await DLGetMajorsByNormalSchool(idNormalSchool)

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: true, message: response.message }
        }
    } catch (error) {
        await LogErrors('GetMajorsByNormalSchool BL SignUps', error)
        return { success: false, message: error || 'Ocurrió un error inesperado' }
    }
}

// const GetFieldsData = async () => {
//     try {
//         const response = await DLGetFieldsData()

//         if (response.success) {
//             return { success: true, data: response.data }
//         } else {
//             return { success: true, message: response.message }
//         }
//     } catch (error) {
//         await LogErrors('GetFieldsData BL SignUps', error)
//         return { success: false, message: error || 'Ocurrió un error inesperado' }
//     }
// }

/**
 * Formatea una fecha al formato deseado.
 * @param {Date} date - Objeto de fecha a formatear.
 * @param {string} format - Formato deseado ('yyyy-MM-dd', 'dd/MM/yyyy', etc.).
 * @returns {string} Fecha formateada.
 */
const GetFormattedDate = async (date, format) => {
    try {
        const options = {
            'yyyy': date.getFullYear(),
            'MM': String(date.getMonth() + 1).padStart(2, '0'),
            'dd': String(date.getDate()).padStart(2, '0')
        }
        
        const formattedDate = format.replace(/yyyy|MM|dd/g, (match) => options[match])

        return { success: true, data: formattedDate }
    } catch (error) {
        await LogErrors('GetFormattedDate BL SignUps', error)
        return { success: false, message: error || 'Ocurrió un error inesperado' }
    }
}

/**
 * Calcula el rango dinámico de fechas.
 * @param {Date} today
 * @returns {Object} Objeto con las fechas mínima y máxima.
 */
const GetCalculateDateRange = async (today) => {
    try {
        const minDate = new Date(today.getFullYear() - 150, today.getMonth(), today.getDate())
        const maxDate = today
    
        if (minDate && maxDate) {
            const minDateResponse = await GetFormattedDate(minDate, 'yyyy-MM-dd')
            const maxDateResponse = await GetFormattedDate(maxDate, 'yyyy-MM-dd')

            if (minDateResponse.success) {    
                if (maxDateResponse.success) {
                    const dateData = {
                        minDate: minDateResponse.data,
                        maxDate: maxDateResponse.data
                    }

                    return { success: true, data: dateData }
                } else {
                    return { success: false, message: '' }
                }
            } else {
                return { success: false, message: '' }
            }
        } else {
            return { success: false, message: '' }
        }
    } catch (error) {
        await LogErrors('GetCalculateDateRange BL SignUps', error)
        return { success: false, message: error || 'Ocurrió un error inesperado' }
    }
}

/**
 * Valida si una fecha está dentro de un rango específico.
 * @param {string} date - Fecha en formato 'yyyy-MM-dd'.
 * @param {string} minDateStr - Fecha mínima en formato 'yyyy-MM-dd'.
 * @param {string} maxDateStr - Fecha máxima en formato 'yyyy-MM-dd'.
 * @returns {boolean} `true` si la fecha está en el rango, de lo contrario `false`.
 */
const IsDateInRange = async (date, minDateStr, maxDateStr) => {
    try {
        //const date = new Date(date)
        const minDate = new Date(minDateStr)
        const maxDate = new Date(maxDateStr)
    
        return { success: true, data: date >= minDate && date <= maxDate }
    } catch (error) {
        await LogErrors('IsDateInRange BL SignUps', error)
        return { success: false, message: error || 'Ocurrió un error inesperado' }
    }
}

const ValidateAverageData = async (value) => {
    try {
        const regex = /^([0-9]|10)(\.\d{0,2})?$/ // Acepta números entre 0 y 10 con hasta 2 decimales

        if (regex.test(value) || value === '') {
            return { success: true, data: value }
        } else {
            return { success: false, message: '' }
        }
    } catch (error) {
        await LogErrors('ValidateAverageData BL SignUps', error)
        return { success: false, message: error || 'Ocurrió un error inesperado' }
    }
}

export { SignUp, GetAllStates, GetStatesContracted, GetNormalSchoolSectors, GetNormalSchoolsByState, GetMajorsByNormalSchool, GetCalculateDateRange, ValidateAverageData }; //GetFieldsData